import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import { IDashboardIndicatorsData } from "../interface";

interface ILI{
    data?: IDashboardIndicatorsData;
	level: string;
	currentPeriod: "S" | "N"
}

const Li: React.FC<ILI> = ({
	data,
	level,
	currentPeriod
}) => {
	const { translate } = useTranslation();
	const history = useHistory();

	return (
		<>
			<div>
				<RCCBadge color="blue" layout="isSquare" onClick={() => history.push(`/indicators/panel/?group=10&level=${level}&currentPeriod=${currentPeriod}`)} >{data?.total || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Total")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare" onClick={() => history.push(`/indicators/panel/?group=10&level=${level}&currentPeriod=${currentPeriod}&situation=0`)} >{data?.withoutValue || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Sem valor")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="yellow" layout="isSquare" onClick={() => history.push(`/indicators/panel/?group=10&level=${level}&currentPeriod=${currentPeriod}&situation=1`)} >{data?.notOnTarget || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Não atingiu")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare" onClick={() => history.push(`/indicators/panel/?group=10&level=${level}&currentPeriod=${currentPeriod}&situation=2`)} >{data?.onTarget || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atingiu a meta")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
